import {attachCloudFilePopup} from "../components/cloud/popup";

$(function () {
    attachCloudFilePopup(
        $(document)
    );
});
